export default __webpack_public_path__ + "static/media/logo-mapfre.b8b17561.jpg";